'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ChartShowMoreToggle.scss');

var ChartShowMore = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ChartShowMore, _PureComponent);

  function ChartShowMore() {
    (0, _classCallCheck3.default)(this, ChartShowMore);
    return (0, _possibleConstructorReturn3.default)(this, (ChartShowMore.__proto__ || (0, _getPrototypeOf2.default)(ChartShowMore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartShowMore, [{
    key: 'onClick',
    value: function onClick() {
      this.props.onClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isOpen = _props.isOpen,
          style = _props.style;
      var t = this.context.t;


      return _react2.default.createElement(
        'a',
        {
          className: (0, _bind2.default)(styles.showMore, className),
          style: style,
          onClick: this.onClick
        },
        _react2.default.createElement(
          'span',
          { className: styles.text },
          isOpen ? t('Show less') : t('Show more')
        ),
        _react2.default.createElement('i', { className: isOpen ? 'icon-order-up' : 'icon-order-down' })
      );
    }
  }]);
  return ChartShowMore;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.object
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onClick: _noop3.default,
  style: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = ChartShowMore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartShowMoreToggle/ChartShowMoreToggle.js
// module id = 1967
// module chunks = 1